import {
    Component,
    Input,
    OnChanges,
    ChangeDetectionStrategy,
    TemplateRef,
} from "@angular/core";

import { Validity } from "../store/validity/state";
import { trackEntity, trackIndex } from "../utils/utils";
import { Helpers } from "../utils/browser";

@Component({
    selector: "zbd-list",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <label *ngIf="label">
            {{ label }}<span *ngIf="required" class="star-required"> *</span>
        </label>
        <div *ngIf="collection" class="row">
            <div
                *ngFor="let column of columns; trackBy: trackIndex"
                class="{{ columnClass }}"
            >
                <ul class="list">
                    <li
                        *ngFor="let item of column; trackBy: trackEntity"
                        class="list-item"
                        [style.max-width]="itemWidth"
                    >
                        <ng-template
                            [ngTemplateOutlet]="template"
                            [ngTemplateOutletContext]="{
                                $implicit: item,
                                validity: validity,
                            }"
                        ></ng-template>
                        <span
                            *ngIf="
                                deleteFn &&
                                (!isRemovableFn || isRemovableFn(item))
                            "
                            class="zas-header-icon icon-close-tag"
                            [ngClass]="{ 'ie-alignment-fix': isRunningInIE }"
                            (click)="deleteFn(item)"
                        ></span>
                    </li>
                </ul>
            </div>
        </div>
        <div *ngIf="addFn" (click)="addFn(collection, {})" class="add-btn">
            <span class="zas-header-icon icon-add"></span>
            <span class="zbd-inline-button">{{ itemName }} hinzufügen</span>
        </div>
    `,
    styles: [
        `
            ul.list {
                padding-left: 0em;
                list-style-type: none;
                margin-bottom: 0;
                margin-top: 0;
            }

            li.list-item {
                padding-bottom: 4px;
            }

            .zas-header-icon {
                margin-right: 2px;
                font-size: 30px;
            }

            .add-btn {
                margin-top: 10px;
            }
            .ie-alignment-fix {
                vertical-align: super;
            }
        `,
    ],
})
export class ZbdListComponent implements OnChanges {
    @Input() label: string;
    @Input() name: string;
    @Input() itemName: string;
    @Input() itemWidth: string;
    @Input() collection: any[];
    @Input() template: TemplateRef<any>;
    @Input() addFn: (collection: any[], item: any) => void;
    @Input() deleteFn: (entity: any) => void;
    @Input() isRemovableFn?: (entity: any) => boolean;
    @Input() validity: Validity;
    @Input() columnNumber = 1;

    required = false;

    trackEntity = trackEntity;
    trackIndex = trackIndex;

    ngOnChanges() {
        if (this.validity && this.validity[this.name]) {
            this.required = this.validity[this.name].required;
        }
    }

    get columns(): any[][] {
        const columns = Array(this.columnNumber)
            .fill(Array)
            .map((x) => x());
        this.collection.forEach((item, index) =>
            columns[index % this.columnNumber].push(item),
        );
        return columns;
    }

    get columnClass(): string {
        const rowsToClass = {
            1: "col-sm-12",
            2: "col-sm-6",
            3: "col-sm-4",
            4: "col-sm-3",
        };
        return rowsToClass[this.columnNumber];
    }

    get isRunningInIE() {
        return Helpers.isInternetExplorer();
    }
}
